import axios from 'axios'
import moment from 'moment'

import store from '@/store'

export default () => {
  // Set the default URL that axios will use
  axios.defaults.baseURL = process.env.VUE_APP_API_URL

  /**
   * Objetivo: Al sensar un http status code 401 forzar el cierre de la sesion
   * y deslogueo del sistema
   */
  axios.interceptors.response.use((response) => {
    return response
  }, (error) => {
    if (typeof error.response !== 'undefined' && error.response.status === 401) {
      if (process.env.NODE_ENV === 'development') {
        console.log('error 401 obtenido')
      }
      store.dispatch('session/logout')
    }
  })

  /**
   * Objetivo: lograr detectar cuando un request se intente hacer con un
   * token expirado, renovarlo y continuar con el request pero usando
   * el nuevo token renovado descartando el viejo.
   */
  axios.interceptors.request.use(async config => {
    // let originalRequest = config
    const dateNow = new Date()

    if (config.headers.Authorization && moment(dateNow).isSameOrAfter(store.state.session.tokenExpiryWarning)) {
      if (process.env.NODE_ENV === 'development') {
        console.log('el token ya expiro se desloguea la sesion')
      }
      store.action.session.logout()
      return false
    } else {
      return config
    }

    // if (originalRequest.headers.Authorization && store.state.session.expiresAt < dateNow.getTime()) {
    //   // Existe el header de Authorization en el request y el mismo está expirado
    //   if (process.env.NODE_ENV === 'development') {
    //     console.log('axios.request.interceptors: renovando token')
    //   }
    //   // Si existe en el request el header de authorization y el token esta vencido
    //   // se solicita la renovacion del token de sesion
    //   await store.dispatch('session/updateAuthTokens')
    //     .catch(error => {
    //       console.log('AxiosSetup request interceptors error: ', error)
    //       // Se cancela el request ya que al intentar renovar el token dio error.
    //       return false
    //     })
    //   if (process.env.NODE_ENV === 'development') {
    //     console.log('axios.request.interceptors: token renovado', store.state.session.accessToken)
    //   }
    //   originalRequest['Authorization'] = `Bearer ${store.state.session.accessToken}`
    //   return originalRequest
    // }
    // return config
  }, (err) => {
    return Promise.reject(err)
  })
}
